import { useGetDashboardPromoCardsQuery } from 'api/dashboardPromoCards'
import Loading from 'components/Loading'
import useDispatch from 'hooks/useDispatch'
import { buildTranslate } from 'locales'
import React, { useCallback, useMemo } from 'react'
import { push } from 'react-router-redux'
import Carousel from './Carousel'
import { resolvePromoLink, toCarouselCards } from './promoCards'

const t = buildTranslate('home.promo')

// The API-driven homepage carousel (flag-on path). Fetches the shown promo
// cards, renders a loading state while fetching, and renders nothing on an
// empty or errored response rather than breaking the Home page.
const PromoCarousel: React.FC = () => {
  const dispatch = useDispatch()
  const { data, isLoading, isError } = useGetDashboardPromoCardsQuery()

  const handleClick = useCallback(
    (linkUrl: string) => {
      const target = resolvePromoLink(linkUrl)
      // Unsafe or unparseable links resolve to null and are a no-op.
      if (!target) {
        return
      }
      if (target.kind === 'internal') {
        dispatch(push(target.path))
      } else {
        window.open(target.url, '_blank', 'noopener,noreferrer')
      }
    },
    [dispatch]
  )

  const cards = useMemo(
    () =>
      toCarouselCards(data ?? [], handleClick, position =>
        t('image_alt', { number: position })
      ),
    [data, handleClick]
  )

  if (isLoading) {
    return <Loading />
  }

  if (isError || cards.length === 0) {
    return null
  }

  return <Carousel cards={cards} />
}

export default PromoCarousel
